import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_CATEGORY_PLANS,
  CREATE_CATEGORY_PLANS,
  DELETE_CATEGORY_PLANS,
  UPDATE_CATEGORY_PLANS,
  RESET_CATEGORY_PLANS,
} from "./actionType";

import {
  CategoryPlansApiResponseSuccess,
  CategoryPlansApiResponseError,
  ResetCategoryPlans as resetCategory,
} from "./action";

import {
  getCategoryPlans as getPlansCategory,
  createCategoryPlans as createPlansCategory,
  updateCategoryPlans as updatePlansCategory,
  deleteCategoryPlans as deletePlansCategory,
} from "../../helpers/backend_helper";

import { notifySuccess, notifyError } from "../../components/notify";

function* getCategoryPlans() {
  try {
    const response = yield call(getPlansCategory);
    yield put(CategoryPlansApiResponseSuccess(GET_CATEGORY_PLANS, response));
  } catch (error) {
    yield put(CategoryPlansApiResponseError(GET_CATEGORY_PLANS, error));
  }
}

function* createCategoryPlans(data) {
  try {
    const response = yield call(createPlansCategory, data.payload.data);
    yield put(CategoryPlansApiResponseSuccess(CREATE_CATEGORY_PLANS, response));
    notifySuccess("Categoria cadastrada com sucesso!");
  } catch (error) {
    yield put(CategoryPlansApiResponseError(CREATE_CATEGORY_PLANS, error));
    notifyError("Erro ao cadastrar categoria!");
  }
}

function* updateCategoryPlans(data) {
  const { payload } = data;
  try {
    const response = yield call(updatePlansCategory, payload.data);
    yield put(CategoryPlansApiResponseSuccess(UPDATE_CATEGORY_PLANS, response));
    notifySuccess("Categoria alterada com sucesso!");
  } catch (error) {
    yield put(CategoryPlansApiResponseError(UPDATE_CATEGORY_PLANS, error));
    notifyError("Erro ao editar categoria!");
  }
}

function* deleteCategoryPlans(data) {
  const { id } = data.payload;
  try {
    const response = yield call(deletePlansCategory, id);
    yield put(CategoryPlansApiResponseSuccess(DELETE_CATEGORY_PLANS, response));
    notifySuccess("Categoria deletada com sucesso!");
  } catch (error) {
    yield put(CategoryPlansApiResponseError(DELETE_CATEGORY_PLANS, error));
    notifyError("Erro ao deletar categoria!");
  }
}

export function* watchGetCategoryPlans() {
  yield takeEvery(GET_CATEGORY_PLANS, getCategoryPlans);
}

export function* watchCreateCategoryPlans() {
  yield takeEvery(CREATE_CATEGORY_PLANS, createCategoryPlans);
}

export function* watchUpdateCategoryPlans() {
  yield takeEvery(UPDATE_CATEGORY_PLANS, updateCategoryPlans);
}

export function* watchDeleteCategoryPlans() {
  yield takeEvery(DELETE_CATEGORY_PLANS, deleteCategoryPlans);
}

function* CategoryPlansSaga() {
  yield all([fork(watchGetCategoryPlans)]);
  yield all([fork(watchCreateCategoryPlans)]);
  yield all([fork(watchUpdateCategoryPlans)]);
  yield all([fork(watchDeleteCategoryPlans)]);
}

export default CategoryPlansSaga;
